import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'

import { Provider } from '@root/entities/provider/model'
import { LiquidityShortFormatted } from '@root/shared/core/format'

import type { PairModel } from '../../atoms'
import type { ClassNameProps } from '@root/shared/react'

type PairLiquidityFormattedProps = {
  pair: PairModel
} & ClassNameProps

const LAUNCHPAD_PROVIDERS = new Set<Provider.Provider>([
  Provider.pumpFun,
  Provider.pumpFunMayhem,
  Provider.bonkFun,
  Provider.raydiumLaunchpad,
])
const DANGER_LIQUIDITY_THRESHOLD = 500

export const PairLiquidityFormatted: React.FC<PairLiquidityFormattedProps> = ({
  pair,
  className,
}) => {
  const [liquidityUsd] = useAtom(pair.liquidityUsd)
  const danger = useMemo(() => {
    if (LAUNCHPAD_PROVIDERS.has(pair.provider)) {
      return false
    }

    return liquidityUsd.lte(DANGER_LIQUIDITY_THRESHOLD)
  }, [liquidityUsd, pair.provider])

  const style = useMemo(() => {
    if (danger) {
      return {
        color: 'var(--error-9)',
      }
    }
    return {}
  }, [danger])

  return (
    <LiquidityShortFormatted
      data-danger={danger}
      liquidity={liquidityUsd}
      className={className}
      style={style}
    />
  )
}
